import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getNaturalezas } from 'api/configuracion';

// eslint-disable-next-line react/prop-types
const Naturalezas = ({ permission }) => (
  <PlainCRUD
    title="Naturalezas"
    permission={permission}
    get={getNaturalezas}
    fields={[defaultFields.descripcion]}
    readOnly
  />
);

export default Naturalezas;
